import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';


import { ApsServiceService } from '../aps-service.service';

@Component({
  selector: 'app-userpage',
  templateUrl: './userpage.component.html',
  styleUrls: ['./userpage.component.css']
})
export class UserpageComponent implements OnInit {
  loaderdata:any=false
  getname:any=localStorage.getItem('FirstName') + " "+localStorage.getItem('LastName')
  userid:any = localStorage.getItem('userid');
  issubscribe:any=localStorage.getItem('issubscribe')
  useremail:any=""
  Firstname:any=" "
  lastname:any=" "
  email:any=" "
  phone:any=" "
  address1:any=" "
  address2:any=" "
  zip:any=" "
  city:any=" "
  state:any=" "
  country:any=" "
  sub:any;
  getdatasub:any;
  rate_other:any='00';
  rate_usa:any='00';
  rate_canada:any='00';
  userdata:any;
  currentfull:any;
  isActiveProfil:any=true;
  isActivesub:any=false;
  isActiveMember:any=false;
  checkActivemember:any=true
  profileview:any='profile';
  
directoryaccess:boolean;
  constructor(private toastr: ToastrService,private router: Router,private searchitem: ApsServiceService) { }

  ngOnInit(): void {
    //console.log(this.issubscribe )

    if(this.issubscribe === 'false'){
      this.profileview='subscription';
      this.isActiveProfil=false;
      this.isActivesub=true;
    }
    if(localStorage.getItem("directory") == 'true'){
      this.directoryaccess=true
    }else{
      this.directoryaccess=false
    }
    //console.log(this.directoryaccess)
    this.loaderdata=true
    const d = new Date();
    var currentyear=d.getFullYear();
    var currentday=d.getDate();
    var currentmonth=d.getMonth()+1;
this.currentfull=currentday+"/"+currentmonth+"/"+2023

    // package

    this.searchitem.getLoginPackage().subscribe((returndata)=>{
      //console.log(returndata)
      this.getdatasub=returndata.plans
      //console.log( this.getdatasub[2]?.plan_validity)
      this.loaderdata=false;
    });
    
    //console.log()
    this.searchitem.getUserdata(this.userid).subscribe((responce) => {
     //console.log(responce)
      if(responce.status){
        this.Firstname=responce.data.FirstName
        this.lastname=responce.data.LastName
        this.email=responce.data.Email
        this.useremail=responce.data.Email
        this.phone=responce.data.Phone
        this.address1=responce.data.Address_1
        this.address2=responce.data.Address_2
        this.zip=responce.data.zip
        this.city=responce.data.city
        this.state=responce.data.State
        this.country=responce.data.Country
      }
      this.loaderdata=false;

  })

  this.searchitem.getSub(this.userid).subscribe((responce) => {
    if(responce.status){
      this.sub=responce.data
    }
    this.loaderdata=false;
    


  })
  }


//   onClickSubmit(data){
//     var userid = localStorage.getItem('userid');
//     //console.log(data)
//     this.searchitem.uploaduser(userid,data).subscribe((responce) => {
//      //console.log(responce)
//       if(responce.status){
//         alert('Record has been successfully Updated')
//       }

//   })
// }
onClickSubmitSub(datas){
  //console.log(datas)
  var userid=localStorage.getItem('userid')
  //console.log('reg');
  //console.log(datas['Canadaplanyear'].split(" ")[0])
 
  var rateitem=datas['Canadaplanyear'].split(" ")[0]
  var selectedyears=datas['Canadaplanyear'].split(" ")[1]
  var donations=0

  var planname=datas['planyear'] + " " +datas['planname'];
  this.userdata={}
  if(!datas['Donation'] ||datas['Donation'] == " " ){
    //console.log("null")
     donations=0;
  }else{
    //console.log("not null")
   donations=datas['Donation']
  }
  this.userdata= {
    "userid":userid,
    "planyear":selectedyears,
    "planname":planname,
    "planamount":rateitem,
    "donations":donations

}
//console.log(this.userdata)
  this.searchitem.subscription(this.userdata).subscribe((responce) => {
//console.log(responce);
if(responce.status){
  alert()
}
  })

}
onChangescanada(data){
  //console.log(data)
  //console.log(data.split(" ")[0])
  this.rate_canada=data.split(" ")[0]

}
onChangesusa(data){
  //console.log(data)
  //console.log(data.split(" ")[0])
  this.rate_usa=data.split(" ")[0]

}
onChangesother(data){
  //console.log(data)
  //console.log(data.split(" ")[0])
  this.rate_other=data.split(" ")[0]

}
check(check){

  //console.log(check)
  if(this.issubscribe ==='true'){
  if(parseInt(localStorage.getItem('flag'))==0){
  if(check == 'profile' ){
    this.profileview='profile';
    this.isActivesub=false;
    this.isActiveProfil=true
    this.isActiveMember=false
  }else if(check == 'subscription' ){
    this.profileview='subscription';
    this.isActivesub=true;
    this.isActiveProfil=false;
    this.isActiveMember=false

  }else{
    this.profileview='memberlist';
    this.isActivesub=false;
    this.isActiveProfil=false;
    this.isActiveMember=true
  }
}else{
this.toastr.warning("Complete the registration to continue!..")
}
  }else{
    this.profileview='subscription';
    this.isActivesub=true;
    this.isActiveProfil=false;
    this.isActiveMember=false
  }



}
}
